import React, { useState, useEffect } from "react";

import { useHistory, useLocation } from "react-router-dom";

import Plan from "../../../../../presentation/pages/register-account/plan";

import { makeRemotePackage } from "../../../usecases/package/remote-package-factory";

import { PackageProps } from "../../../../../domain/models/package.model";
import { api } from "../../../../../infra/http/remote";
import toastUtils from "../../../../../utils/ToastUtils";

const MakePlan: React.FC = () => {
  const history = useHistory();

  const { pathname } = useLocation();

  const [, registerType] = pathname.split("/");

  const [packageList, setPackageList] = useState<PackageProps[]>();

  const email = localStorage.getItem("username");

  useEffect(() => {
    const loadPackages = async (): Promise<void> => {
      const packageResponse =
        (await makeRemotePackage().loadAll()) as unknown as PackageProps[];
      setPackageList(packageResponse);
    };
    loadPackages();
  }, []);

  const handleSubmit = async (values: any): Promise<void> => {

    const body = {
      email,
      pack: { id: values.id },
    };

    try {
      await api.post("/public/register/developer/package", body);
      toastUtils.showMessage({
        type: "success",
        message: "Salvo com sucesso!",
      });
      history.push(`/${registerType}/3`);
    } catch (error: any) {
      toastUtils.showMessage({
        type: "error",
        message: `Erro ao salvar informações:${
          error?.detail || error?.userMessage
        }`,
      });
   
    }
  };

  const props = {
    packageList,
    handleSubmit,
  };

  return <Plan {...props} />;
};

export default MakePlan;
